import api from '@/api/base';

// API URLs for authentication
const URLS = {
  login: '/admins/signin',
  clientLogin: '/user/test-login',
  register: '/auth/register',
  me: '/auth/me',
  adminMe: '/admins/me',
  userMe: '/user/me',
  logout: '/auth/logout',
  refreshToken: '/auth/refresh',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
} as const;

interface LoginPayload {
  email: string;
  password: string;
}

interface ClientLoginPayload {
  TIN: string;
  contractId?: string;
  alias?: string;
}

interface ResetPasswordPayload {
  token: string;
  password: string;
}

// Auth API methods
const authApi = {
  // User login
  login: ({ email, password }: LoginPayload) => {
    return api.post(URLS.login, { email, password });
  },

  clientLogin: ({ TIN, contractId, alias }: ClientLoginPayload) => {
    const payload: ClientLoginPayload = { TIN };
    if (contractId) payload.contractId = contractId;
    if (alias) payload.alias = alias;
    return api.post(URLS.clientLogin, payload);
  },

  // User registration
  register: (userData: Record<string, unknown>) => {
    return api.post(URLS.register, userData);
  },

  // Get current user info
  getMe: (token?: string) => {
    return api.get(URLS.me, { token });
  },

  // Get admin user info
  getAdminMe: (token?: string) => {
    return api.get(URLS.adminMe, { token });
  },

  // Get regular user info
  getUserMe: (token?: string) => {
    return api.get(URLS.userMe, { token });
  },

  // Logout user
  logout: (token?: string) => {
    return api.post(URLS.logout, {}, { token });
  },

  // Refresh auth token
  refreshToken: (refreshToken: string) => {
    return api.post(URLS.refreshToken, { refreshToken });
  },

  // Forgot password
  forgotPassword: (email: string) => {
    return api.post(URLS.forgotPassword, { email });
  },

  // Reset password
  resetPassword: ({ token, password }: ResetPasswordPayload) => {
    return api.post(URLS.resetPassword, { token, password });
  },
};

// Keep both named and default exports for flexibility
export default authApi;
